import { render, staticRenderFns } from "./TopCampaignsComponent.vue?vue&type=template&id=5413a956"
import script from "./TopCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./TopCampaignsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jorgerebelo/Documents/Internal/corporate-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5413a956')) {
      api.createRecord('5413a956', component.options)
    } else {
      api.reload('5413a956', component.options)
    }
    module.hot.accept("./TopCampaignsComponent.vue?vue&type=template&id=5413a956", function () {
      api.rerender('5413a956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/wp-content/themes/kwankotheme/assets/js/components/campaigns_directory/TopCampaignsComponent.vue"
export default component.exports